window.respimage && window.respimage({
  elements: [document.images[document.images.length - 1]]
});
